import type {
  HoldChoice,
  PlayHoldCount,
  PlayHoldKind,
} from '@/types/custom-playbooks';

export type HoldCounts = Record<string, number>;
export type HeldRecords =
  | { counts: HoldCounts; message?: string }
  | {
      waiting: Record<PlayHoldKind, number> & { capacity?: number };
      message?: string;
    };
/** Each waiting count's words. Retry holds the Instantly capacity gate
 *  parked count apart, under `capacity`. */
export const HOLD_KIND_LABELS: Record<PlayHoldCount, string> = {
  retry: 'Retries',
  wait: 'Waits',
  approval: 'Approvals',
  handoff: 'Handoffs',
  capacity: 'Waiting for room in Instantly',
};
export class HoldDecisionCancelled extends Error {}

export function holdsAffectedCounts(value: unknown): HoldCounts {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
  return Object.fromEntries(
    Object.entries(value).filter(
      ([id, count]) =>
        id.length > 0 &&
        typeof count === 'number' &&
        Number.isSafeInteger(count) &&
        count > 0
    )
  );
}

/** HTTPException is wrapped by the installed API handler. Counts never go back in a request. */
export function heldRecordsError(error: unknown): HeldRecords | undefined {
  const data = (
    error as
      | { data?: { error?: { details?: unknown }; detail?: unknown } }
      | undefined
  )?.data;
  const detail = data?.error?.details ?? data?.detail;
  if (!detail || typeof detail !== 'object') return;
  const body = detail as {
    code?: unknown;
    holds_affected?: unknown;
    message?: unknown;
  };
  if (body.code !== 'holds_affected') return;
  const counts = holdsAffectedCounts(body.holds_affected);
  if (!Object.keys(counts).length) return;
  return {
    counts,
    ...(typeof body.message === 'string' ? { message: body.message } : {}),
  };
}

export const holdsBody = (holds?: HoldChoice) => (holds ? { holds } : {});
